import { Tag } from '@tryhackme/thm-ui-components';
import type { FC } from 'react';
import { SupportedLanguage } from 'src/common/contexts/language-context';
import type { InfluencerSubscriptionCampaignModalContentProps } from '../influencer-subscription-campaign-modal/influencer-subscription-campaign-modal.types';
import { StyledModalContainer, StyledTag } from './modal-content.styles';
export const SubscriptionContentModal: FC<InfluencerSubscriptionCampaignModalContentProps> = ({
  campaign,
  userFriendlyName,
  language,
  hideInfluencerDetails = false
}) => {
  const isRedditCampaign = campaign?.name === 'REDDIT_2025';
  return <StyledModalContainer uppercaseTitle data-sentry-element="StyledModalContainer" data-sentry-component="SubscriptionContentModal" data-sentry-source-file="subscription-content.modal.tsx">
      {!hideInfluencerDetails && <StyledTag>
          <Tag size="small" data-testid="campaign-title">
            {language === SupportedLanguage.FRENCH ? `Offre exclusive pour les spectateurs de ${userFriendlyName}` : `${userFriendlyName} Viewers Exclusive`}
          </Tag>
        </StyledTag>}
      {language === SupportedLanguage.ENGLISH && <>
          <h2>
            <span>{campaign?.amount}% off</span> annual subscriptions!
          </h2>
          <p data-testid="campaign-promotion-text">
            {isRedditCampaign && "You've unlocked a Reddit user exclusive offer!"}
            {!hideInfluencerDetails && !isRedditCampaign && `You\'ve unlocked a ${userFriendlyName} viewers exclusive offer!`}
            {hideInfluencerDetails && !isRedditCampaign && "You've unlocked a special offer!"}
          </p>
        </>}
      {language === SupportedLanguage.FRENCH && <>
          <h2>
            <span>-{campaign?.amount}%</span> sur les abonnements annuels!
          </h2>
          <p data-testid="campaign-promotion-text">
            {isRedditCampaign && "Vous'avez débloqué une offre exclusive réservée aux utilisateurs de Reddit!"}
            {!hideInfluencerDetails && !isRedditCampaign && `Vous\'avez débloqué une offre exclusive réservée aux spectateurs de ${userFriendlyName}!`}
            {hideInfluencerDetails && !isRedditCampaign && "Vous'avez débloqué une offre exclusive!"}
          </p>
        </>}
    </StyledModalContainer>;
};